import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { _error, _setAxios, _success } from 'lib/Helper';

const handleSelectRole = (roleId, roleSelected) => {
  _setAxios("user/role-used/"+roleSelected?.data?.user_id+"/"+roleId, "PUT", {
      is_used: 1
  }).then(resp => {
      if (resp.status === true) {
          _success('topRight', 'Success', resp.data.message)
          window.location.href = process.env.REACT_APP_BASE_URL;
      } else {
          _error('topRight', 'Error', resp.data.message)
      }
  })
};

const fetch = (data, callback) => {
  let results = []
  data?.forEach(row => {
    results.push({
      value: row.role_id,
      data: row,
      label: (
        <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}>{row.role_nama}</span>
          {row.is_used === "1" && <CheckCircleOutlined />}
        </span>
      ),
    })
  });
  callback(results);
};
const SearchInput = (props) => {
  return (
    <Select
      {...props}
      placeholder={
        props.placeholder ? props.placeholder : 'Pilih jabatan'
      }
      style={props.style ? props.style : { width: '100%', padding: '0 8px', marginTop: 8 }}
      defaultActiveFirstOption={false}
      filterOption={false}
      notFoundContent={null}
      onSelect={handleSelectRole}
    />
  );
};
const SelectRolesActive = ({ data: propData, ...props }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(propData, setData);
  }, [propData]);

  return <SearchInput
    {...props}
    options={data}
  />
}

export default SelectRolesActive;